import type { CardHooks } from "./registry";

/**
 * Unbroken Sands — engine: the data-driven mechanics array on the card already
 * handles cost-reduction (attack) and gain-stamina (full block). The counter
 * grants come from counterGrants. This module exists so the registry has an
 * entry — used to log when the card resolves.
 */
export const unbrokenSands: CardHooks = {};
